export enum SettingType {
  Menu = 'Menu',
  Category = 'Category',
  Item = 'Item',
  Employee = 'Employee',
  Discount = 'Discount',
  Tv = 'Tv',
  Nugget = 'Nugget',
  TimeOff = 'TimeOff',
}
